import { render, staticRenderFns } from "./ClubDetails.vue?vue&type=template&id=4a0593e2&scoped=true"
import script from "./ClubDetails.vue?vue&type=script&lang=js"
export * from "./ClubDetails.vue?vue&type=script&lang=js"
import style0 from "./ClubDetails.vue?vue&type=style&index=0&id=4a0593e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0593e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0593e2')) {
      api.createRecord('4a0593e2', component.options)
    } else {
      api.reload('4a0593e2', component.options)
    }
    module.hot.accept("./ClubDetails.vue?vue&type=template&id=4a0593e2&scoped=true", function () {
      api.rerender('4a0593e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/ClubDetails.vue"
export default component.exports